import { PointUtils } from '../../math';
import { getRoot } from '../fragment';
export function getArtboard(fragment) {
    return getRoot(fragment).artboard;
}
export function getArtboardCenter(fragment) {
    var artboard = getArtboard(fragment);
    return PointUtils.add(artboard.point, PointUtils.divide(artboard.size, 2));
}
export function getArtboardSize(fragment) {
    var artboard = getArtboard(fragment);
    return artboard.size;
}
export function getArtboardPoint(fragment) {
    var artboard = getArtboard(fragment);
    return artboard.point;
}
export function getTitle(fragment) {
    return getRoot(fragment).title;
}
